import { useEffect, useState } from 'react';
import {Box, Button, TextField} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Divider } from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';
import UniDialog from '../Common/UniDialog';
import { getLetianStaff, getLetianStaffTemp } from '../../actions/qtActions';
import { handleTextualizeDriverNameAndVehicleType } from '../../utilities/common';
import { useDispatch, useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  section: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  boxStyle: {
    height: 750
  }
}));

export default function PickupList(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { isDataLoading, createRows, columns, list, setValue, handleSubmit, type, title, dialogTitle, dialogMessage, dialogPlaceholder, pickupWarehouse } = props;

  const DEFAULT_ROWS_PER_PAGE = 20;

  const searchList = useSelector(state => state.ddReducer.getLetianStaff)

  const [selected, setSelected] = useState([]);
  const [pageSize, setPageSize] = useState(DEFAULT_ROWS_PER_PAGE);
  const [openDialog, setOpenDialog] = useState(false);
  const [assignDriverName, setAssignDriverName] = useState('...');
  const [driverListTemp, setDriverListTemp] = useState([]);

  function handleValue(targetValue) {
    if(type === 'fetch') {
      setAssignDriverName(handleTextualizeDriverNameAndVehicleType(targetValue, pickupWarehouse, driverListTemp, searchList));
    }
    setValue(targetValue);
  }

  useEffect(() => {
    if(pickupWarehouse) {
      // London and Toronto could cross transfer drivers
      if(pickupWarehouse === 2) {
        dispatch(getLetianStaffTemp(14))
        .then((res) => {
          setDriverListTemp(res);
        })
      }
      if(pickupWarehouse === 14) {
          dispatch(getLetianStaffTemp(2))
          .then((res) => {
            setDriverListTemp(res);
          })
      }
    }
  }, [pickupWarehouse])
  useEffect(() => {
    if(openDialog) {
      if(type === 'fetch') {
        setAssignDriverName('...');
      }
    }
  }, [openDialog, type])

  return (
    <Box style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
        <div className={classes.section} style={{flexGrow: 1}}>
          <DataGrid
            loading={isDataLoading}
            alignItems="center"
            rows={createRows()||[]}
            columns={columns}
            onSelectionModelChange={(newSelection) => {
                setSelected(newSelection);
            }}
            checkboxSelection
            style={{height: 600}}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20,50,{value:list.length,label:'All'}]}
            pagination
          />
        </div>
        <Divider />
        <div className={classes.section}>
          <Button 
            color='primary' 
            variant='contained'
            disabled={selected.length<=0||(type==='create'&&pickupWarehouse===`-1`)}
            onClick={()=>setOpenDialog(true)}
          >
            {title}
          </Button>
        </div>
        <UniDialog
          title={dialogTitle}
          message={dialogMessage}
          fullWidth
          open={openDialog}
          onClose={()=>setOpenDialog(false)}
          onFinish={()=>handleSubmit(selected)}
          buttonDisabled={type==='fetch'&&assignDriverName==='...'}
        >
          {
            type &&
            type === 'fetch' &&
            <div>
              {assignDriverName}
            </div>
          }
          <TextField
              style={{marginTop: 10}}
              autoFocus
              fullWidth
              placeholder={dialogPlaceholder}
              onChange={(e)=> handleValue(e.target.value)}
          />
        </UniDialog>
    </Box>
  );
}